import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import { ze } from 'utils/zhEn';
import MetricKitFlameGraph from 'components/exception/MetricKitPage/MetricKitFlameGraph';

const MetricKitFlameGraphModal = ({
  visible,
  data,
  onClose,
}) => {
  const title = data?.diagnosticType === 'disk'
    ? ze('MetricKit 磁盘写入火焰图', 'MetricKit Disk Flame Graph')
    : ze('MetricKit CPU 火焰图', 'MetricKit CPU Flame Graph');

  // Modal header 约 55px，top offset 24px，bottom margin 24px，各留一点 buffer，合计减去约 140px
  const modalBodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100vh - 140px)',
    overflow: 'hidden',
    padding: '16px 24px',
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      maskClosable={false}
      footer={null}
      width="calc(100vw - 120px)"
      style={{ top: 24 }}
      bodyStyle={modalBodyStyle}
      destroyOnClose
    >
      {visible && <MetricKitFlameGraph data={data} />}
    </Modal>
  );
};

MetricKitFlameGraphModal.propTypes = {
  visible: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
};

export default MetricKitFlameGraphModal;
